import ConnectionPreview from "diagram-js/lib/features/connection-preview/ConnectionPreview";
import EventBus from "diagram-js/lib/core/EventBus";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {subProcessType, taskType} from "@ispm-shared/modules/bpmn";

export class CustomConnectionPreview extends ConnectionPreview {

  constructor(private injector, private eventBus: EventBus, private canvas,private elementFactory) {
    super(injector, eventBus, canvas,elementFactory);
    // No need to register, base class already did
  }

  getConnection (canConnect,source, target) {

    if(ModelingUtil.getElementType(source) === taskType || ModelingUtil.getElementType(source) === subProcessType) {
      var attrs = {"type":'bpmn:SequenceFlow'};
      return super.getConnection(attrs,source,target);
    }
  };
}
